export default [{
        name: "pro_dialog_ProjectInfoMenuid",
        path: "/proDialog/ProjectInfoMenuid/:pageSize/:page/:urlParam",
        component: resolve => require(["../components/pages/materials/project/infoTable.vue"], resolve)
    }, {
        name: "pro_dialog_unitInfoMenuid",
        path: "/proDialog/unitInfoMenuid/:pageSize/:page/:urlParam",
        component: resolve => require(["../components/pages/materials/project/unitInfoMenu.vue"], resolve)
    }, {
        name: "pro_dialog_PojectItemMenu",
        path: "/proDialog/PojectItemMenuid/:urlParam",
        component: resolve => require(["../components/pages/materials/project/PojectItemMenu.vue"], resolve)
    }, {
        name: "pro_dialog_ZYItemMenu",
        path: "/proDialog/ZYItemMenu/:urlParam",
        component: resolve => require(["../components/pages/materials/project/ZYItemMenu.vue"], resolve)
    }, {
        name: "pro_dialog_BuildPersonMenu",
        path: "/proDialog/BuildPersonMenu/:urlParam",
        component: resolve => require(["../components/pages/materials/project/BuildPersonMenu.vue"], resolve)
    }, {
        name: "pro_dialog_SuperPersonMenu",
        path: "/proDialog/SuperPersonMenu/:urlParam",
        component: resolve => require(["../components/pages/materials/project/SuperPersonMenu.vue"], resolve)
    },
    {
        name: "pro_dialog_DangerMenu",
        path: "/proDialog/DangerMenu/:urlParam",
        component: resolve => require(["../components/pages/materials/project/DangerMenu.vue"], resolve)
    },
    {
        name: "pro_dialog_AttachmentMenu",
        path: "/proDialog/AttachmentMenu/:urlParam",
        component: resolve => require(["../components/pages/materials/project/AttachmentMenu.vue"], resolve)
    },
    {
        name: "pro_dialog_Inspection",
        path: "/proDialog/Inspection/:urlParam",
        component: resolve => require(["../components/pages/materials/project/Inspection.vue"], resolve)
    },
    {
        name: "pro_dialog_constrInfo",
        path: "/proDialog/constrInfo/:urlParam",
        component: resolve => require(["../components/pages/materials/project/constrInfo.vue"], resolve)
    },
    {
        name: "pro_dialog_PersonChangeMenu",
        path: "/proDialog/PersonChangeMenu/:urlParam",
        component: resolve => require(["../components/pages/materials/project/PersonChangeMenu.vue"], resolve)
    },

]


// WEBPACK FOOTER //
// ./src/router/materialsRouter.js